var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column mt-5 mx-auto menuBotoes"},[_vm._l((_vm.menuBotoes),function(item,index){return _c('v-btn',{key:index,class:item.class,attrs:{"dark":"","to":{ name: item.name },"target":item.target}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(" "+_vm._s(item.icon)+" ")]),_vm._v(" "+_vm._s(item.title)+" ")],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }